import { ThemeOptions } from '@mui/material';

import { capitalDesignTokens } from '../../capital_design_tokens';

export const MuiBreadcrumbs: ThemeOptions['components']['MuiBreadcrumbs'] = {
  defaultProps: {
    slotProps: {
      collapsedIcon: {
        sx: {
          position: 'absolute',
          bottom: 0
        }
      }
    }
  },
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.text.secondary,
      fontSize: capitalDesignTokens.foundations.typography.fontSize.bodySmall,
      '.MuiButtonBase-root': {
        position: 'relative',
        height: '20px',
        minWidth: '24px',
        backgroundColor: 'transparent',
        '&:focus': {
          backgroundColor: 'transparent',
          outline: `2px solid ${theme.palette.common.black}`
        },
        '&:focus-visible': {
          backgroundColor: 'transparent',
          outline: `2px solid ${theme.palette.primary.main}`
        },
        '.MuiTouchRipple-root': {
          display: 'none'
        }
      }
    }),
    li: {
      display: 'flex',
      alignItems: 'center'
    }
  }
};
